(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ac2-countdown"] && !Shopify.designMode) return;
  try {
    
  class Ac2Countdown {
    static SECOND = 1000;
    static MINUTE = 60 * 1000;
    static HOUR = 60 * 60 * 1000;
    static DAY = 24 * 60 * 60 * 1000;

    constructor(root) {
      this.root = root;
      this.target = Date.parse(root.dataset.ac2Countdown);
      this.behaviour = root.dataset.ac2CountdownExpired || 'message';
      this.message = root.querySelector('[data-ac2-countdown-message]');
      this.units = {
        days: root.querySelector('[data-ac2-unit="days"]'),
        hours: root.querySelector('[data-ac2-unit="hours"]'),
        minutes: root.querySelector('[data-ac2-unit="minutes"]'),
        seconds: root.querySelector('[data-ac2-unit="seconds"]'),
      };
      this.previous = {};

      if (Number.isNaN(this.target)) {
        this.root.hidden = true;
        return;
      }

      this.tick();
      this.timer = window.setInterval(() => this.tick(), Ac2Countdown.SECOND);
    }

    destroy() {
      window.clearInterval(this.timer);
    }

    pad(value) {
      return String(Math.max(0, value)).padStart(2, '0');
    }

    write(key, value) {
      const el = this.units[key];
      if (!el) return;
      const next = this.pad(value);
      if (this.previous[key] === next) return;
      this.previous[key] = next;
      el.textContent = next;
      el.classList.add('is-ticking');
      window.setTimeout(() => el.classList.remove('is-ticking'), 220);
    }

    expire() {
      this.destroy();
      this.root.classList.add('is-expired');

      if (this.behaviour === 'hide') {
        const section = this.root.closest('.ac2-countdown');
        if (section) section.hidden = true;
        return;
      }

      if (this.message && this.message.textContent.trim() !== '') {
        this.message.hidden = false;
      }
    }

    tick() {
      const remaining = this.target - Date.now();

      if (remaining <= 0) {
        Object.keys(this.units).forEach((key) => this.write(key, 0));
        this.expire();
        return;
      }

      this.write('days', Math.floor(remaining / Ac2Countdown.DAY));
      this.write('hours', Math.floor((remaining % Ac2Countdown.DAY) / Ac2Countdown.HOUR));
      this.write('minutes', Math.floor((remaining % Ac2Countdown.HOUR) / Ac2Countdown.MINUTE));
      this.write('seconds', Math.floor((remaining % Ac2Countdown.MINUTE) / Ac2Countdown.SECOND));
    }
  }

  const ac2Countdowns = new WeakMap();

  function ac2InitCountdowns(root) {
    (root || document).querySelectorAll('[data-ac2-countdown]').forEach((el) => {
      if (ac2Countdowns.has(el)) return;
      ac2Countdowns.set(el, new Ac2Countdown(el));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => ac2InitCountdowns());
  } else {
    ac2InitCountdowns();
  }

  document.addEventListener('shopify:section:load', (event) => ac2InitCountdowns(event.target));

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-ac2-countdown]').forEach((el) => {
      const instance = ac2Countdowns.get(el);
      if (instance) instance.destroy();
      ac2Countdowns.delete(el);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ac2-editions-carousel"] && !Shopify.designMode) return;
  try {
    
  class Ac2Carousel {
    constructor(root) {
      this.root = root;
      this.thumb = root.parentElement.querySelector('[data-ac2-carousel-thumb]');
      this.pointerId = null;
      this.startX = 0;
      this.startScroll = 0;
      this.moved = 0;
      this.dragging = false;
      this.suppressClick = false;
      this.threshold = 6;

      this.onScroll = this.onScroll.bind(this);
      this.onPointerDown = this.onPointerDown.bind(this);
      this.onPointerMove = this.onPointerMove.bind(this);
      this.onPointerUp = this.onPointerUp.bind(this);
      this.onClickCapture = this.onClickCapture.bind(this);

      this.root.addEventListener('scroll', this.onScroll, { passive: true });
      this.root.addEventListener('pointerdown', this.onPointerDown);
      this.root.addEventListener('click', this.onClickCapture, true);

      this.resizeObserver = new ResizeObserver(() => this.sync());
      this.resizeObserver.observe(this.root);
      this.sync();
    }

    destroy() {
      this.root.removeEventListener('scroll', this.onScroll);
      this.root.removeEventListener('pointerdown', this.onPointerDown);
      this.root.removeEventListener('click', this.onClickCapture, true);
      window.removeEventListener('pointermove', this.onPointerMove);
      window.removeEventListener('pointerup', this.onPointerUp);
      window.removeEventListener('pointercancel', this.onPointerUp);
      this.resizeObserver.disconnect();
    }

    sync() {
      if (!this.thumb) return;
      const { scrollWidth, clientWidth, scrollLeft } = this.root;
      if (scrollWidth <= 0) return;
      const scale = Math.min(1, clientWidth / scrollWidth);
      const offset = (scrollLeft / scrollWidth) * clientWidth;
      this.thumb.style.setProperty('--ac2-thumb-scale', String(scale));
      this.thumb.style.setProperty('--ac2-thumb-x', `${offset}px`);
    }

    onScroll() {
      if (this.frame) return;
      this.frame = window.requestAnimationFrame(() => {
        this.frame = null;
        this.sync();
      });
    }

    onPointerDown(event) {
      if (event.pointerType === 'touch' || this.pointerId !== null) return;
      if (event.button !== 0) return;

      this.pointerId = event.pointerId;
      this.startX = event.clientX;
      this.startScroll = this.root.scrollLeft;
      this.moved = 0;
      this.dragging = false;

      window.addEventListener('pointermove', this.onPointerMove);
      window.addEventListener('pointerup', this.onPointerUp);
      window.addEventListener('pointercancel', this.onPointerUp);
    }

    onPointerMove(event) {
      if (event.pointerId !== this.pointerId) return;

      const delta = event.clientX - this.startX;
      this.moved = Math.max(this.moved, Math.abs(delta));

      if (this.moved <= this.threshold) return;

      if (!this.dragging) {
        this.dragging = true;
        this.root.classList.add('is-dragging');
      }

      event.preventDefault();
      this.root.scrollLeft = this.startScroll - delta;
    }

    onPointerUp(event) {
      if (event.pointerId !== this.pointerId) return;

      this.pointerId = null;
      this.suppressClick = this.dragging;
      this.root.setAttribute('data-ac2-dragged', String(this.dragging));
      this.dragging = false;
      this.moved = 0;
      this.root.classList.remove('is-dragging');

      window.removeEventListener('pointermove', this.onPointerMove);
      window.removeEventListener('pointerup', this.onPointerUp);
      window.removeEventListener('pointercancel', this.onPointerUp);
    }

    onClickCapture(event) {
      if (!this.suppressClick) return;
      this.suppressClick = false;
      this.root.setAttribute('data-ac2-dragged', 'false');
      event.preventDefault();
      event.stopPropagation();
    }
  }

  const ac2Carousels = new WeakMap();

  function ac2InitCarousels(root) {
    (root || document).querySelectorAll('[data-ac2-carousel]').forEach((el) => {
      if (ac2Carousels.has(el)) return;
      ac2Carousels.set(el, new Ac2Carousel(el));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => ac2InitCarousels());
  } else {
    ac2InitCarousels();
  }

  document.addEventListener('shopify:section:load', (event) => ac2InitCarousels(event.target));

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-ac2-carousel]').forEach((el) => {
      const instance = ac2Carousels.get(el);
      if (instance) instance.destroy();
      ac2Carousels.delete(el);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ac2-hero"] && !Shopify.designMode) return;
  try {
    
  class Ac2Reveal {
    static observed = new WeakSet();

    static init(root) {
      const targets = (root || document).querySelectorAll('.ac2__reveal:not(.is-revealed)');
      if (targets.length === 0) return;

      if (!('IntersectionObserver' in window)) {
        targets.forEach((el) => el.classList.add('is-revealed'));
        return;
      }

      const observer = new IntersectionObserver(
        (entries, obs) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-revealed');
            obs.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -10% 0px', threshold: 0.08 }
      );

      targets.forEach((el) => {
        if (Ac2Reveal.observed.has(el)) return;
        Ac2Reveal.observed.add(el);
        observer.observe(el);
      });
    }
  }

  window.Ac2Reveal = Ac2Reveal;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => Ac2Reveal.init());
  } else {
    Ac2Reveal.init();
  }

  document.addEventListener('shopify:section:load', (event) => Ac2Reveal.init(event.target));


  /** FB pixel */

window.addEventListener("klaviyoForms", function (e) {
  if (e.detail.type == 'submit') {
    // add Facebook tracking pixel code here
    !function (f, b, e, v, n, t, s) {
      if (f.fbq) return; n = f.fbq = function () {
        n.callMethod ?
          n.callMethod.apply(n, arguments) : n.queue.push(arguments)
      };
      if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0';
      n.queue = []; t = b.createElement(e); t.async = !0;
      t.src = v; s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s)
    }(window, document, 'script',
      'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '225981648771540');
    fbq('track', 'Lead');
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ac2-key-highlights"] && !Shopify.designMode) return;
  try {
    
  class Ac2Slider {
    constructor(root) {
      this.root = root;
      this.track = root.querySelector('[data-ac2-slider-track]');
      if (!this.track) return;

      this.dots = Array.from(root.querySelectorAll('[data-ac2-slider-dot]'));
      this.prev = root.querySelector('[data-ac2-slider-prev]');
      this.next = root.querySelector('[data-ac2-slider-next]');
      this.count = this.track.children.length;
      this.current = 0;

      this.onScroll = this.onScroll.bind(this);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.goTo(Number(dot.dataset.ac2SliderDot)));
      });

      if (this.prev) this.prev.addEventListener('click', () => this.step(-1));
      if (this.next) this.next.addEventListener('click', () => this.step(1));
    }

    destroy() {
      if (this.track) this.track.removeEventListener('scroll', this.onScroll);
    }

    step(direction) {
      if (this.count === 0) return;
      this.goTo((this.current + direction + this.count) % this.count);
    }

    goTo(index) {
      this.track.scrollTo({ left: this.track.clientWidth * index, behavior: 'smooth' });
    }

    setActive(index) {
      this.current = index;
      this.dots.forEach((dot, i) => {
        if (i === index) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    onScroll() {
      if (this.frame) return;
      this.frame = window.requestAnimationFrame(() => {
        this.frame = null;
        const width = this.track.clientWidth;
        if (width === 0) return;
        this.setActive(Math.round(this.track.scrollLeft / width));
      });
    }
  }

  const ac2Sliders = new WeakMap();

  function ac2InitSliders(root) {
    (root || document).querySelectorAll('[data-ac2-slider]').forEach((el) => {
      if (ac2Sliders.has(el)) return;
      ac2Sliders.set(el, new Ac2Slider(el));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => ac2InitSliders());
  } else {
    ac2InitSliders();
  }

  document.addEventListener('shopify:section:load', (event) => ac2InitSliders(event.target));

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-ac2-slider]').forEach((el) => {
      const instance = ac2Sliders.get(el);
      if (instance) instance.destroy();
      ac2Sliders.delete(el);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
